// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3M-V0","label":"styles_label__8GHiA"};